export enum SitecoreReportTypeEnum {
  Individual = 'individual',
  Club = 'club',
  District = 'district',
  Region = 'region',
}
